import * as React from "react";
import VopHeader from "components/vop_header";

import VopFooter from "components/vop_footer";

import HomeHeader from "components/HomeHeader";
import "./style.scss";
import { queryPlanList } from "utils/api";

export default class NoticeList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
    };
  }
  componentDidMount() {
    document.title = "京东VOP开放平台-白皮书";
    window.scrollTo(0, 0);
    this.init();
  }
  init() {
    console.log("ss");
    queryPlanList().then((res) => {
      // console.log(res);
      if (res?.data?.success) {
        this.setState({
          list: res.data.result,
        });
      }
    });
  }
  render() {
    return (
      <React.Fragment>
        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_header"
                data-version="6.0.0"
              >
                <VopHeader contentWidth="1200px">
                  <HomeHeader />
                </VopHeader>
              </div>
            </div>
          </div>
        </div>

        <div className="paper-content">
          <div className="content-banner">
            <img
              src="https://img14.360buyimg.com/imagetools/jfs/t1/121510/16/17899/296658/5fa909f1E7e3accab/7ee77f1da8082020.jpg"
              alt=""
            />
          </div>
          <div className="content-list">
            <div className="list">
          
              {this.state.list.map((item, index) => {
                return (
                  <div className="item" key={index}>
                    <div className="title">
                      <span className="tag">{item.industryName}</span>
                      <span className="name">{item.planName}</span>
                    </div>
                    <div className="content">{item.planDetail}</div>
                    <div className="control">
                      <div className="down">
                        <a href={item.planFileUrl} download={item.planName}>
                          <img src="//img14.360buyimg.com/imagetools/jfs/t1/210871/34/964/628/61445e25E3bc91b65/f10b2a8a7aedebfc.png" alt="" />
                          下载
                        </a>
                      </div>
                      <div className="preview">
                        <a
                          href={item.planFileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src="//img10.360buyimg.com/imagetools/jfs/t1/79047/1/17306/632/61445e4aE6c77397d/4e4cb236b590d902.png" alt="" />
                          预览
                        </a>{" "}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_footer"
                data-version="2.0.0"
              >
                <VopFooter />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
